import React, { Component } from 'react'
import * as styles from "./StoriesSection.module.scss";
import { Link } from "react-router-dom";

import ScrollSection from "../ScrollSection/ScrollSection";
import storiesImg from '../../../../assets/homepage/stories-section-img.png';

class StoriesSection extends Component {

  componentDidMount() {
    // Adding our Stories Unit
    const script = document.createElement("script");
    script.setAttribute("id", "7373f96680ac4704b8048a595c7a8203");
    script.innerText = (`cnxps.cmd.push(function () { cnxps({ playerId: '016e249f-027c-41a4-99d8-8b5133556f39' }).render('7373f96680ac4704b8048a595c7a8203');});`);

    const storiesContainer = document.getElementById('story-player');
    storiesContainer.appendChild(script);
  }

  render() {
    return (
        <section className={styles['homepage-stories']} id="homepage-stories">
          <div className={styles['homepage-container']}>
            <div className={styles['homepage-stories-container']}>
              <div className={styles['homepage-stories__content']}>
                <ScrollSection playspaceActive={true}/>
                <h2 className={styles['homepage-section__title']}>
                  Create vertical inventory with the flip of a switch.
                </h2>
                <p className={styles['homepage-section__subtitle']}>
                  Repurpose your social content on-site and in-app for enhanced revenue and engagement.
                </p>
                <Link to="/playspace" className={styles['homepage-stories__link']}>ENGAGE ON MOBILE</Link>
              </div>
              <div className={styles['homepage-stories__img-container']}>
                <img src={storiesImg} alt="" className={styles['homepage-stories__img']}/>
                <div className={styles['homepage-stories__player']}>
                  <div id="story-player"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }
}

export default StoriesSection;